import { http, HttpResponse, HttpResponseResolver, delay } from "msw";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { ApiCatalog } from "@/api";
import { v3SchoolThroughSchoolAdminMock } from "./queries.test.mock";
import type { V3SchoolThroughSchoolAdminResponse } from "./queries.type";

export const createV3SchoolThroughSchoolAdminQueryHandler = (
  {
    defaultData,
    status,
  }: {
    defaultData?: Partial<V3SchoolThroughSchoolAdminResponse> | undefined;
    status?: number;
  } = {
    defaultData: v3SchoolThroughSchoolAdminMock,
    status: 200,
  },
) => {
  const mockedResolver = jest.fn(async () => {
    await delay(100);
    return HttpResponse.json(defaultData || v3SchoolThroughSchoolAdminMock, {
      status: status || 200,
    });
  }) as unknown as jest.MockedFunction<HttpResponseResolver>;
  const get = http.get(
    `${MONOLITH_ORIGIN}${ApiCatalog.schoolThroughSchoolAdmin.endpoint.replace(
      "[id]",
      "me",
    )}`,
    mockedResolver,
  );
  return {
    get,
    mockedResolver,
  };
};
